import script from "./shipment-items-table.vue?vue&type=script&setup=true&lang=js"
export * from "./shipment-items-table.vue?vue&type=script&setup=true&lang=js"

import "./shipment-items-table.vue?vue&type=style&index=0&id=76be11a5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76be11a5"]])

export default __exports__